import { render, staticRenderFns } from "./oversold_detail.vue?vue&type=template&id=7e794c58&scoped=true"
import script from "./oversold_detail.vue?vue&type=script&lang=js"
export * from "./oversold_detail.vue?vue&type=script&lang=js"
import style0 from "./oversold_detail.vue?vue&type=style&index=0&id=7e794c58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e794c58",
  null
  
)

export default component.exports